import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
`;

export const SDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 6px;
  margin-right: 8px;
`;
